import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import validate from 'validate.js';

import PasswordChangedDialog from './PasswordChangedDialog';

const CHANGE_PASSWORD = gql`
mutation($currentPassword: String!, $newPassword: String!) {
    changeOwnPassword(currentPassword: $currentPassword, newPassword: $newPassword)
  }
`;

const ChangePasswordDialog = props => {
  const [passwordChangedDialogOpen, setPasswordChangedDialogOpen] = React.useState(false);
  const { open, onClose } = props;
  const [invalidInput, setInvalidInput] = useState(false);
  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    errors: {}
  });
  const [changePassword] = useMutation(CHANGE_PASSWORD, { variables: { currentPassword: formState.values.currentPassword, newPassword: formState.values.newPassword } });

  const handlePasswordChangedDialogOpen = () => {
    if (!passwordChangedDialogOpen) {
      setPasswordChangedDialogOpen(true);
    }
  };

  const handlePasswordChangedDialogOpenClose = () => {
    if (passwordChangedDialogOpen) {
      setPasswordChangedDialogOpen(false);
      onClose();
    }
  };

  const handleChange = (event) => {
    event.persist();
    const errors = validate(formState.values, schema);
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.value,
      },
      isValid: !errors,
      errors: errors || {},
    }));
  };

  const handleVerifyClick = async () => {
    try {
      const result = await changePassword();
      if (result.data) {
        setInvalidInput(false);
        handlePasswordChangedDialogOpen();
      } else {
        setInvalidInput(true);
      }
    } catch (error) {
      console.log(error);
      setInvalidInput(true);
    }
  };

  const hasError = (field) => (formState.errors[field]);

  return (
    <Dialog open={open} onClose={onClose}>
      <AppBar position="static" color="primary">
        <Toolbar>
          <div><Typography variant="h5">Passwort ändern</Typography></div>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <form noValidate autoComplete="off" style={{display: 'flex', flexDirection: 'column'}}>
          <TextField
            className="text-field"
            color="primary"
            error={hasError('currentPassword')}
            fullWidth
            label="Aktuelles Passwort"
            name="currentPassword"
            onChange={handleChange}
            type="password"
            value={formState.values.currentPassword}
            variant="standard"
          />
          <TextField
            className="text-field"
            color="primary"
            error={hasError('newPassword')}
            fullWidth
            label="Neues Passwort"
            name="newPassword"
            onChange={handleChange}
            type="password"
            value={formState.values.newPassword}
            variant="standard"
          />
          {invalidInput ? (
            <Typography variant="body1" color="error">
              Bitte Überprüfen Sie Ihre Eingaben.
            </Typography>
          ) : <></>}
        </form>
      </DialogContent>

      <DialogActions>
        <Button color="primary" onClick={onClose}>Abbrechen</Button>
        <Button color="primary" variant="contained" disabled={!formState.isValid} onClick={handleVerifyClick}>Bestätigen</Button>
      </DialogActions>
      <PasswordChangedDialog open={passwordChangedDialogOpen} onClose={handlePasswordChangedDialogOpenClose} />
    </Dialog>
  );
};

const schema = {
  currentPassword: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128,
    }
  },
  newPassword: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128,
    },
  },
};

ChangePasswordDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ChangePasswordDialog;